import { Flatfile } from '@flatfile/api';
import { TenantCSVType } from '../types';
import { v4 as uuid } from 'uuid';

export const processTenantData = (
  sheet: Flatfile.Sheet | undefined,
  sheetDataRecords: Flatfile.RecordsWithLinks
): TenantCSVType[] => {
  return sheetDataRecords
    .filter((record: Flatfile.RecordWithLinks) => record.valid)
    .map((record: Flatfile.RecordWithLinks) => {
      const tenant: TenantCSVType = {
        _id: uuid(),
        name: '',
        displayName: '',
        tenantType: '',
        suites: '',
        sourceType: '',
        externalLeaseId: '',
        whiteListedEmailDomains: '',
      };

      sheet?.config.fields.forEach((field: Flatfile.Property) => {
        const fieldKey = field.key;
        const recordValue = record.values[fieldKey]
          ? (record.values[fieldKey].value as string | undefined) || ''
          : '';

        switch (fieldKey) {
          case 'name':
            tenant.name = recordValue;
            break;
          case 'displayName':
            tenant.displayName = recordValue;
            break;
          case 'tenantType':
            tenant.tenantType = recordValue;
            break;
          case 'suites':
            tenant.suites = recordValue;
            break;
          case 'sourceType':
            tenant.sourceType = recordValue;
            break;
          case 'externalLeaseId':
            tenant.externalLeaseId = recordValue;
            break;
          case 'whiteListedEmailDomains':
            tenant.whiteListedEmailDomains = recordValue;
            break;
        }
      });

      return tenant;
    });
};
